'use client';

import { IntlProvider } from 'react-intl';
import { Provider as ReduxProvider } from 'react-redux';
import { useParams } from 'next/navigation';
import { sdk } from 'sdk';
import { rootStore } from 'store';
import { useDataDogLogging } from 'frontastic/hooks';
import { AuthenticationProvider } from './authentication';
import { SWRProvider } from './swr';
import { TracingProvider } from './tracing';
import { ProvidersProps } from './types';

export const Providers = ({ page, children }: ProvidersProps) => {
  const { locale } = useParams();
  useDataDogLogging();

  sdk.defaultConfigure(locale);

  return (
    <TracingProvider page={page}>
      <IntlProvider locale="en">
        <ReduxProvider store={rootStore}>
          <SWRProvider value={{ fallback: {} }}>
            <AuthenticationProvider locale={locale}>
              {children}
            </AuthenticationProvider>
          </SWRProvider>
        </ReduxProvider>
      </IntlProvider>
    </TracingProvider>
  );
};
